"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var V = function V() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      transform: "translate(-373.101 -275.642)",
      d: "M376.874,282.24c.4-.671.787-1.328,1.185-1.976a12.359,12.359,0,0,1,4.4-4.14,5.956,5.956,0,0,1,1.039-.446.433.433,0,0,1,.562.2.59.59,0,0,1,0,.7c-.257.294-.525.578-.8.86a23.344,23.344,0,0,0-3.157,4.011,24.375,24.375,0,0,0-1.649,3.409c-.165.4-.35.793-.524,1.19a.877.877,0,0,1-1.311.314,2.244,2.244,0,0,1-.619-.8,7.937,7.937,0,0,0-1.229-2.07c-.4-.438-.854-.825-1.285-1.235-.036-.034-.078-.061-.117-.092a.548.548,0,0,1,.057-.975,2.179,2.179,0,0,1,1.888-.1,3.111,3.111,0,0,1,1.036.678C376.528,281.925,376.707,282.086,376.874,282.24Z"
    })
  });
};
exports.V = V;